import { render, staticRenderFns } from "./SaiSelectSingle.vue?vue&type=template&id=512dc155&scoped=true"
import script from "./SaiSelectSingle.vue?vue&type=script&lang=js"
export * from "./SaiSelectSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512dc155",
  null
  
)

export default component.exports